import React, { FC } from 'react';
import { format } from 'date-fns';
import { TOrganization } from '@pages/Organizations/components/OrganizationsTable/types';

export const dateFormatter:FC<TOrganization> = (organization) => {
  const date = format(new Date(organization.createdAt), 'MM/dd/yyyy');

  return <ul>{String(date)}</ul>;
};
